export enum AddToCartType {
    STANDARD = 'PFM - Standard Add to Cart',
    RECS = 'PFM - Product Recs Add to Cart',
}
